import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Link,
  Outlet,
  Navigate,
} from "react-router-dom";

import CharacterSheet from "~/pages/CharacterSheet/CharacterSheet";
import GmView from "~/pages/GmView/GmView";
import Rules from "~/pages/Rules/Rules";
import { ThemeToggle } from "~/widgets/ThemeToggle/ThemeToggle";
import ConstructionBanner from "~/widgets/ConstructionBanner/ConstructionBanner";
import GlobalCommandPalette from "~/widgets/GlobalCommandPalette/GlobalCommandPalette";
import NotificationOverlay from "~/widgets/NotificationOverlay/NotificationOverlay";
import DialogOverlay from "~/widgets/DialogOverlay/DialogOverlay";
import { SettingsProvider } from "~/contexts/SettingsProvider";
import { FocusProvider } from "~/contexts/FocusContext";
import { NotificationProvider } from "~/contexts/NotificationProvider";
import { DialogProvider } from "~/contexts/DialogProvider";
import styles from "~/App.module.scss";

/**
 * Layout component that provides the common structure for all pages,
 * including navigation and footer, styled with Tailwind CSS.
 */
const Layout: React.FC = () => {
  return (
    <FocusProvider>
      <NotificationProvider>
        <DialogProvider>
          <div className={styles.app}>
            <GlobalCommandPalette />
            <NotificationOverlay />
            <DialogOverlay />
            <ConstructionBanner />
            <nav className={styles.nav}>
              <div className={styles.navContainer}>
                <div className={styles.navContent}>
                  <div className={styles.navLeft}>
                    <span className={styles.logo}>
                      Divide TTRPG
                    </span>
                    <ul className={styles.navList}>
                      <li>
                        <Link
                          to="/character"
                          className={styles.navLink}
                        >
                          Character Sheet
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/gm"
                          className={styles.navLink}
                        >
                          GM View
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/rules"
                          className={styles.navLink}
                        >
                          Rules
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className={styles.navRight}>
                    <ThemeToggle />
                  </div>
                </div>
              </div>
            </nav>

            <main className={styles.main}>
              {/* Outlet renders the child route's element */}
              <div className={styles.mainContent}>
                <Outlet />
              </div>
            </main>

            {/*<footer className={styles.footer}>
                <div className={styles.footerContainer}>
                    <p className={styles.footerText}>
                        &copy; {new Date().getFullYear()} Divide TTRPG. All rights reserved.
                    </p>
                </div>
            </footer>*/}
          </div>
        </DialogProvider>
      </NotificationProvider>
    </FocusProvider>
  );
};

/**
 * Configure routes using the Data API (createBrowserRouter).
 * This enables features like loaders, actions, and fetchers.
 */
const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Navigate to="/character" replace />,
      },
      {
        path: "character",
        element: (
          <SettingsProvider>
            <CharacterSheet />
          </SettingsProvider>
        ),
      },
      {
        path: "rules",
        element: <Rules />,
      },
      {
        path: "gm",
        element: (
          <SettingsProvider>
            <GmView />
          </SettingsProvider>
        ),
      },
    ],
  },
]);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
